import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from "../../Context/ConfigContext"
import axios from 'axios';
import { Link } from 'react-router-dom';

const Dashbord = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)

    const GetCustomerInfo = async (e) => {
        e?.preventDefault();
        setLoading(true)
        const headers = apiHeaderJson;

        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerInfo`, { headers })
            setData(response.data.data[0])
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        GetCustomerInfo();
    }, []);

    return (
        <div className="card">
            {loading ? (
                    <div>
                        <div className="shimmer-line" style={{ width: '30%', height: '40px', marginBottom:"25px" }}></div>
                        <div className="shimmer-line" style={{ width: '80%', height: '50px' }}></div>
                    </div>
            ) : (
                <>
                    <div className="card-header">
                        <h3 className="mb-0">Hello {data?.customer_name}!</h3>
                    </div>
                    <div className="card-body">
                        <p>
                            From your account dashboard, you can easily check &amp; view your{' '}
                            <Link to={'/MyOders'}>recent orders</Link>,<br />
                            manage your <Link to={'/MyAddress'}>shipping and billing addresses</Link> and{' '}
                            <Link to={'/MyAccountDetails'}>edit your password and account details.</Link>
                        </p>
                    </div>
                </>
            )}
        </div>
    )
}

export default Dashbord;
